import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { SnapshotFormat } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type InfolayerItem from 'webapp/models-custom/infolayer-item/board-snapshot';

interface Args {
	model: InfolayerItem;
	onClose: () => void;
}

export default class InfolayerTypeBoardSnapshotComponent extends Component<Args> {
	@service('analytics') declare analyticsService: Service.Analytics;

	get title() {
		return this.args.model.board.name;
	}

	@action
	download(format: SnapshotFormat): void {
		const url = this.args.model.snapshotData?.find((d) => d.format === format)?.url;
		if (url) {
			this.analyticsService.event(TrackingEvent.DATABOARD_DOWNLOADED, {
				name: this.title,
				datasources: this.args.model.board.specificSourceTypesKeys,
				origin: 'databoard_preview',
				format,
				type: 'databoard',
			});

			window.open(url);
		}
	}

	<template>
		<div role="button" class="infolayer infolayer--type-board-snapshot {{@model.classes}}">
			<div>
				<CommonUiIconComponent @name="Databoards" @size="lg" @class="infolayer-icon" />
				{{#if @model.isLoading}}
					<p>Your dashboard <strong>"{{this.title}}"</strong> is being prepared.</p>
				{{else if @model.isError}}
					<p>
						We've encountered the following error while generating your dashboard
						<strong>"{{this.title}}"</strong>
						:{{@model.errorText}}
					</p>
				{{else}}
					<p>
						<strong>{{this.title}}</strong>
					</p>
					<div class="controls2">
						<div class="controls2__right">
							<a class="close" {{on "click" @onClose}}>Dismiss</a>
							<a class="button" {{on "click" (fn this.download SnapshotFormat.JPG)}}>
								<CommonUiIconComponent @name="Download" @size="sm" />JPG
							</a>
							<a class="button" {{on "click" (fn this.download SnapshotFormat.PDF)}}>
								<CommonUiIconComponent @name="Download" @size="sm" />PDF
							</a>
						</div>
					</div>
				{{/if}}
			</div>
		</div>
	</template>
}
